<script lang="ts">
	export let selected = true
	export let title: string
	export let type: string = '' // '' | 'price'
</script>


<div class="filter {type}" class:selected>
	<div class="filter__inner">
		<button class="filter__title" on:click={() => (selected = !selected)}>
			<div class="filter__title__inner">
				<span class="question">{title}</span>
			</div>
			<span class="opener" />
		</button>
		<div class="filter__answer">
			<slot />
		</div>
	</div>
</div>


<style lang="scss">
	.filter {
		transition: all linear 0.125s;

		button {
			width: 100%;
			text-align: left;
			color: #000;
			font-weight: 700;
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin: 0;
			cursor: pointer;
			transition: all linear 0.125s;
			padding: 10px 0;
		}

		span.opener {
			position: relative;
			pointer-events: none;
			display: block;
			width: 18px;
			height: 18px;
			border: 2px solid #000;
			border-radius: 5px;
			transition: all linear 0.25s;

			&::before,
			&::after {
				content: '';
				position: absolute;
				border-bottom: 2px solid #000;
				width: 10px;
				left: 4px;
				top: calc(50% - 1px);
				transition: all linear 0.25s;
			}

			&::after {
				transform: rotate(90deg);
			}
		}

		&__title {
			&__inner {
				font-size: 16px;
				display: flex;
				justify-content: space-between;
				align-items: center;
				flex-grow: 1;
				width: calc(100% - 30px);
			}
		}

		&__answer {
			visibility: hidden;
			opacity: 0;
			padding: 0;
			border-top: 1px solid var(--grey--border);
			margin: 0 !important;
			transition: all linear 0.125s;
			height: 0;
			pointer-events: none;
			color: black;
		}

		&.selected {
			.filter {
				&__answer {
					visibility: visible;
					opacity: 1;
					position: static;
					pointer-events: all;
					height: auto;
					padding: 20px 0 15px;
				}
			}

			.opener {
				&::before,
				&::after {
					transform: none;
				}
			}

			&.price {
				.filter {
					&__answer {
						padding-top: 5px;
						padding-bottom: 20px;
					}
				}
			}
		}
	}
</style>
